(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  document.addEventListener('DOMContentLoaded', () => {
    const accordionItems = document.querySelectorAll('[data-collection-accordion-item]');
    if (!accordionItems.length) return;

    const closeItem = (item) => {
      const toggle = item.querySelector('[data-collection-accordion-toggle]');
      const content = item.querySelector('.collection-children-ai');
      if (!toggle || !content) return;
      item.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      content.hidden = true;
    };

    const openItem = (item) => {
      const toggle = item.querySelector('[data-collection-accordion-toggle]');
      const content = item.querySelector('.collection-children-ai');
      if (!toggle || !content) return;
      item.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      content.hidden = false;
    };

    accordionItems.forEach((item) => {
      const toggle = item.querySelector('[data-collection-accordion-toggle]');
      if (!toggle) return;

      toggle.addEventListener('click', () => {
        const shouldOpen = !item.classList.contains('is-open');
        accordionItems.forEach((otherItem) => {
          if (otherItem !== item) closeItem(otherItem);
        });

        if (shouldOpen) openItem(item);
        else closeItem(item);
      });
    });

    const childAccordionItems = document.querySelectorAll('[data-collection-child-accordion-item]');
    childAccordionItems.forEach((item) => {
      const toggle = item.querySelector('[data-collection-child-toggle]');
      const content = item.querySelector('.collection-grandchildren-ai');
      if (!toggle || !content) return;

      toggle.addEventListener('click', () => {
        const isOpen = item.classList.contains('is-open');
        item.classList.toggle('is-open', !isOpen);
        toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        content.hidden = isOpen;
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
